import { useStateContext } from '../../context';
import { Job } from '../Resume/Experience';
import { For, Show } from 'solid-js';
import './jobdescription.scss';
import { dateToString } from '../../Utility/utility.tsx';

export function JobDescription() {
    let state = useStateContext();
    return (
        <Show when={(state.selectedEntity() as any).jobs}>
            <div class="job-card">
                <h2 class="job-company">{(state.selectedEntity() as any).jobs[0].company}</h2>
                <img class="job-logo" src={(state.selectedEntity() as any).jobs[0].logoImg} alt="Company Logo"></img>
                <div class="jobs">
                <For each={(state.selectedEntity() as any).jobs}>
                    {(job: Job) => {
                        return (
                            <div class="job">
                                <h3 class="job-title">{job.title}</h3>
                                <h4 class="job-date">{dateToString(job.start)} - {dateToString(job.end) == dateToString(new Date()) ? "Present" : dateToString(job.end)}</h4>
                                <div class="job-roles">
                                    <For each={job.role}>
                                        {(role: string) => {
                                            return (
                                                <>
                                                    <span class="job-role">◉ {role}</span>
                                                    <br></br>
                                                </>
                                            )
                                        }}
                                    </For>
                                </div>
                                <p></p>
                            </div>
                        )
                    }}
                </For>
                </div>
            </div>
        </Show>
    );
}
